<template>
  <div>
     <el-card>
      <search-form ref="searchForm" :topVisible="true" :tabData="tabData" labelWidth="120px" :searchFormData="searchFormData" @search="search" @tabChange="tabChange">
        <template #topBtn>
          <el-button type="primary" size="small" @click="handleClick('create')">{{ $t('text.add') }}</el-button>
          <el-button type="primary" size="small" @click="handleExport">{{$t('button.batchExport')}}</el-button>
          <import-button class="marginLeft10" :name="$t('button.batchImport')" :api="insertExcel" @sucImport="search"></import-button>
        </template>
      </search-form>
      <create-table :operationColWidth="200" @handleNewTab="handleNewTab($event, 'memberDetail')" :autoWidth="true" :operateVisible="operateVisible" ref="createTable" :loading="loading" :btnType="[]" :total_count="pageData.total_count ? pageData.total_count : 0" :current_page.sync="pageData.page" :papeSize.sync="pageData.per_page" @selectionChange="selectionChange" :topButtonVisible="true" :tableData="tableData" :tableDataItem="tableDataItem" @operate="handleClick" :pageVisible="true" :pageData="pageData" :checkBoxVisible="dropDataItem.length > 0" @handleSort="handleSort" @onSwitchChange="handleCreateTableSwitchChange">
        <template #topButton>
          <span v-if="dropDataItem.length > 0" class="marginRight20 spanminWith">{{`${$t('text.selected')}：${selectionData.length}`}}</span>
          <allButton :buttonDisabled="selectionData.length < 1" :buttonDataItem="dropDataItem" class="marginRight20" @chooseDropItem="chooseDropItem"></allButton>
        </template>
        <template #rightBtn="scope">
          <el-button class="margintop10" :class="item.action === 'view' ? 'operate_view' : ''" v-for="(item, index) in scope.row.member_actions.default_actions" :key="'default_actions' + index" :type="item.type && item.type === 'warn' ? 'danger' : 'primary'" size="mini" @click="handleClick(item, scope.row)">{{item.name}}</el-button>
          <el-button class="margintop10" v-for="(item, index) in scope.row.member_actions.custom_actions" :key="'custom_actions' + index" :type="item.type && item.type === 'warn' ? 'danger' : 'primary'" size="mini" @click="handleCusClick(item)">{{item.name}}</el-button>
        </template>
      </create-table>
    </el-card>
    <router-view/>
    <dialogEffect v-if="dialogVisible" :opereteDate="false" :todayVisible="true" :dialogVisible.sync="dialogVisible" :data="dialogData" @doNextConfirm="doNextConfirm"></dialogEffect>
  </div>
</template>

<script>
import { getMembersSetup, getMembersList, getMembersExport, membersEdit, insertExcel } from '@/services/members'
import jsonData from './jsonData.js'
import allButton from '@/components/allButton'
import searchForm from '@/components/searchForm'
import createTable from '@/components/createTable'
import dialogEffect from '@/components/dialogEffect'
import importButton from '@/components/importButton'
import { mixin } from '@/mixins/mixin'

export default {
  name: 'managerUserOrders',
  mixins: [mixin],
  components: {
    searchForm,
    createTable,
    allButton,
    dialogEffect,
    importButton
  },
  data () {
    return {
      tableDataItem: jsonData.tableDataItem,
      isTabChange: false,
      insertExcel: insertExcel,
      setupParams: {
        scope: 'all'
      }
    }
  },
  watch: {
    $route (to, from) {
      // console.log(from)
      // if (from.name === 'managerUserOrderView') {
      //   this.$nextTick(() => {
      //     this.search()
      //     this.$refs.createTable.$refs.table.doLayout()
      //   })
      // }
    }
  },
  created () {
    const app_name = process.env.VUE_APP_NAME
    if (!app_name.includes('wholesale')) {
      this.tableDataItem.splice(5, 1)
    }
    this.setupParams.scope = 'all'
    this.queryData(getMembersSetup, this.setupParams)
  },
  activated () {
    if (this.isActive) this.queryData(getMembersSetup)
    this.isActive = true
  },
  methods: {
    // 导出数据接口
    handleExport () {
      this.$refs.searchForm.commonOperate(getMembersExport, (data) => {
        this.$router.push({
          name: 'memberDownloadCenter',
          params: { data }
        })
      }, this)
    },
    // 点击操作按钮
    async handleClick (type, data) {
      if (type?.action === 'view') {
        this.$router.push({
          name: 'memberDetail',
          params: {
            id: data.id.value
          },
          query: {
            action: type.action
          }
        })
      }
      if (type?.action === 'edit') {
        this.$router.push({
          name: 'memberEdit',
          params: {
            id: data.id.value
          }
        })
      }
      if (type?.action === 'manage_address') {
        // window.localStorage.setItem('curr_user_id_eq', data.id.value)
        this.$router.push({
          name: 'memberAddressList',
          params: {
            id: data.id.value
          }
        })
      }
      if (type === 'create') {
        this.$router.push({
          name: 'memberAdd'
        })
      }
    },
    tabChange (index) {
      this.isTabChange = true
      this.setupParams.scope = this.tabData[index].value

      this.queryData(getMembersSetup, this.setupParams)
    },
    // 查询
    search (data) {
      if (this.isTabChange) {
        this.isTabChange = false
        return
      }
      if (data) {
        this.searchData = Object.assign({}, data)
      }
      const { page, per_page } = this.pageData
      Object.assign(this.searchData, { page, per_page })
      this.loading = true
      getMembersList(this.searchData).then(res => {
        if (res.data) {
          this.tableData = res.data.objects
          this.tabData = res.data.scopes
          Object.assign(this.pageData, res.data.pagination)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleCreateTableSwitchChange (data) {
      const _this = this
      const { rowData, jsonItemData } = data
      const params = {
        user: {
          active: rowData.active.value
        }
      }
      if (jsonItemData.prop === 'active') {
        this.loading = true
        membersEdit(rowData.id.value, params).then(() => {
          _this.loading = false
          _this.$message({
            type: 'success',
            message: _this.$t('message.operateSuccess')
          })
          _this.search()
        }).catch(() => {
          _this.loading = false
          _this.search()
        })
      }
    }
  }
}
</script>

<style>

</style>
